import { render, staticRenderFns } from "./channel-private.vue?vue&type=template&id=6cb12f70&scoped=true"
import script from "./channel-private.vue?vue&type=script&lang=js"
export * from "./channel-private.vue?vue&type=script&lang=js"
import style0 from "./channel-private.vue?vue&type=style&index=0&id=6cb12f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb12f70",
  null
  
)

export default component.exports